<template>
  <div class="accordion-faq wow move-up">
    <b-card no-body>
      <b-card-header header-tag="header">
        <b-button block v-b-toggle.accordion-1 class="faq-title">Generate PIF documents</b-button>
      </b-card-header>
      <b-collapse id="accordion-1" visible accordion="my-accordion">
        <b-card-body>
          <b-card-text>Product Information File (PIF) documentation and compliance regulation are accomplished with ease. Regulatory documents and PIFs can be generated on-the-go whenever you need them. Customize your documents with your templates, utilizing our powerful template scripting.</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body>
      <b-card-header header-tag="header">
        <b-button block v-b-toggle.accordion-2 class="faq-title">Collaborate with your team</b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion">
        <b-card-body>
          <b-card-text>As the Apif app is a cloud-based software as a service (SaaS), you have full access whenever and wherever. Invite your team for remote collaboration, create multiple workspaces if needed, and accelerate your quality assurance and PIF regulatory documents.</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body>
      <b-card-header header-tag="header">
        <b-button block v-b-toggle.accordion-3 class="faq-title">Secure safe ingredients</b-button>
      </b-card-header>
      <b-collapse id="accordion-3" accordion="my-accordion">
        <b-card-body>
          <b-card-text>Apif enables you to take full management control of your cosmetic products. Ingredients are flagged if they are prohibited or has a restriction of use. Receive notification and warnings if your products contain unsafe ingredients based on EU standards and regulations.</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "Accordion",
};
</script>